module.exports = __webpack_public_path__ + "img/meter-reset-grey.387aa3cb.svg";